
import React, { useEffect, useState } from 'react';
import Exercise from '../Exercise/Exercise';
import SideBar from '../SideBar/SideBar';
import { addToDb, deleteShoppingCart, getStoredCart } from '../fakeDb/fakeDb';
import './Home.css'

const Home = () => {

   const [exercises, setExercises] = useState([])

   const [cart, setCart] = useState([]);

   const clearCart =()=>{
      setCart([]);
      deleteShoppingCart ();
   }
  

   useEffect(() => {
      fetch('exercises.json')
         .then(res => res.json())
         .then(data => setExercises(data))

   }, [])

   //bata bage theke id neyar jonno----console un difind dekhabe  
   useEffect(() => {
      const storedCart = getStoredCart();
      const savedCart = [];
      for (const id in storedCart) {
         const addedExercise = exercises.find(exercise => exercise.id === id);
         if (addedExercise) {
            const quantity = storedCart[id];
            addedExercise.quantity = quantity;
            savedCart.push(addedExercise);
         }
      }
      setCart(savedCart);
   }, [exercises])


   const handleAddToCart = (selectedProduct) => {
      console.log(selectedProduct);
      let newCart = [];
      const exists = cart.find(product => product.id === selectedProduct.id);
      if (!exists) {
         selectedProduct.quantity = 1;
         newCart = [...cart, selectedProduct];
      }
      else {
         const rest = cart.filter(product => product.id !== selectedProduct.id);
         exists.quantity = exists.quantity + 1;
         newCart = [...rest, exists];
      }

      

      setCart(newCart);
      addToDb(selectedProduct.id);
   }





   return (
      <div className='main-container'>

         <div className="exercise-container">

            {
               exercises.map(exercise => <Exercise
                  key={exercise.id}
                  exercise={exercise}
                  handleAddToCart={handleAddToCart}

               ></Exercise>)
            }
         </div>

         <div className="details-container">
            <SideBar clearCart={clearCart} cart={cart}></SideBar>
         </div>

      </div>
   );
};

export default Home;